var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorner3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 138,
    viewBox: "0 0 237 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237 137.092V0H0.709473C1.62248 0.326035 2.53483 0.653362 3.44687 0.980578C10.7249 3.59174 17.9832 6.19583 25.3969 8.07979C38.4464 11.3596 51.0296 15.6833 63.7664 20.0597C66.3604 20.9511 68.9608 21.8446 71.5728 22.7319C74.3532 23.6798 77.1589 24.5804 79.9674 25.4819C89.4382 28.5219 98.9414 31.5724 107.618 36.4805C113.208 39.6283 118.871 42.6303 124.531 45.6304C131.161 49.1446 137.785 52.6562 144.281 56.3964C145.616 57.1643 146.972 57.8796 148.337 58.5994C151.056 60.0336 153.81 61.4858 156.495 63.4082C160.063 65.9622 161.683 68.6546 163.745 72.0836C164.014 72.5309 164.291 72.9907 164.581 73.4644C170.303 82.5394 177.417 90.6226 185.652 97.4066C187.992 99.403 190.146 101.608 192.295 103.807C194.416 105.978 196.53 108.143 198.812 110.095C201.874 112.782 205.049 115.349 208.225 117.918C211.595 120.642 214.966 123.368 218.205 126.239C221.37 129.038 228.605 132.894 237 137.092Z",
    fill: "#414141"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorner3);
export default __webpack_public_path__ + "static/media/corner_3.15b841979b84721fce95e70b95143cde.svg";
export { ForwardRef as ReactComponent };